export default function getFirstName(
  name: string | null | undefined,
): string | null {
  if (!name) return null;

  const nameWords = name.split(' ').filter(word => Boolean(word));

  return nameWords[0];
}
